<script lang="ts">
    import Fa from 'svelte-fa'
    import { faAngleLeft, faPlusCircle, faSave, faTrashAlt, faUser } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, get_current_component, onMount } from 'svelte/internal'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import { GridBadge, GridBadgeClassEnum, GridButton, GridClass, GridCol, GridColTypeEnum, GridItemShow, GridLine } from '../_common/z/zgrid'
    import Zframe from '../_common/z/zframe.svelte'
    import Zact from '../_common/z/zact.svelte'
    import { PartnerPerson } from '../../modules/toolsApi/partners/persons/partner-person.entity'
    import type { Partner } from '../../modules/toolsApi/partners/partners/partner.entity'
    import dayjs from 'dayjs'
    import { PartnerEntry } from '../../modules/toolsApi/partners/entries/partner-entry.entity'
    import type { CreatePartnerEntryDto } from '../../modules/toolsApi/partners/entries/dto/create-partner-entry.dto'
    import DateSelect from '../_common/date-select.svelte'
    const dispatch = createEventDispatcher()

    const me = get_current_component()

    let show = false
    let step = 1
    let entities: PartnerEntry[] = []
    let entity: PartnerEntry = new PartnerEntry()
    let paidAt: string = null
    let partnerId: string = null

    let partners: Partner[] = []
    let persons: PartnerPerson[] = []

    onMount(async () => {
        await loadPartners()
        await loadPersons()
        await loadEntities()
    })

    async function loadPersons() {
        persons = await window.api.tools.partners.persons.getAll({ excluded: true })
        console.log('persons', persons)
    }

    async function loadPartners() {
        partners = await window.api.tools.partners.partners.getAll({ excluded: true })
        partners = await window.api.utils.utils.assignPersonsFromObject(partners)
    }

    async function loadEntities() {
        try {
            show = true
            entities = []
            entities = await window.api.tools.partners.entries.getAll({ partnerId, from: dates.from, to: dates.to })
            for (let entity of entities) {
                const partnerPersonId = persons.find((el) => el.partnersPersonsId === entity.partnersPersonsId)?.personId
                if (partnerPersonId) {
                    entity['partnerPersonId'] = partnerPersonId
                }
                const personId = partners.find((el) => el.partnerId === entity.partnerId)?.personId
                if (personId) {
                    entity['personId'] = personId
                }
            }
            entities = await window.api.utils.utils.assignPersonsFromObject(entities, 'partnerPersonId', 'partnerPerson')
            entities = await window.api.utils.utils.assignPersonsFromObject(entities, 'personId', 'person')
            await loadBalance()
            console.log('entries', entities)
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let totals: { partnerId: string; pending: number; paid: number; released: number; date: Date } = null
    async function loadBalance() {
        totals = await window.api.tools.partners.entries.getTotals(partnerId)
        console.log('totals', totals)
    }

    async function editEntity(id: string) {
        try {
            show = true
            entity = new PartnerEntry()
            entity = await window.api.tools.partners.entries.getOne(id)
            paidAt = dayjs(entity.paidAt).format('YYYY-MM-DD HH:mm')
            console.log('entity', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new PartnerEntry()
        paidAt = dayjs(new Date()).format('YYYY-MM-DD HH:mm')
        step = 2
    }

    async function saveEntity() {
        if (entity.partnersEntriesId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function createEntity() {
        try {
            show = true
            entity.paidAt = new Date(paidAt)
            const dto: CreatePartnerEntryDto = {
                partnerId: entity.partnerId,
                paidAt: entity.paidAt,
                description: entity.description,
                type: entity.type,
                value: entity.value,
            }
            entity = await window.api.tools.partners.entries.create(dto)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            entity.paidAt = new Date(paidAt)
            const dto: CreatePartnerEntryDto = {
                partnerId: entity.partnerId,
                paidAt: entity.paidAt,
                description: entity.description,
                type: entity.type,
                value: entity.value,
            }
            await window.api.tools.partners.entries.update(entity.partnersEntriesId, dto)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.tools.partners.entries.remove(entity.partnersEntriesId)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Extrato'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Origem', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Liberação', type: GridColTypeEnum.date }))
        if (!partnerId) {
            grid.cols.push(new GridCol({ content: 'Parceiro' }))
        }
        grid.cols.push(new GridCol({ content: 'Indicado' }))
        //grid.cols.push(new GridCol({ content: 'Inclusão', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Descrição' }))
        grid.cols.push(new GridCol({ content: 'Tipo', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Valor líquido', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        if (totals) {
            grid.box.push({ label: 'Disponível', value: totals.released - totals.paid, decimals: 2 })
            grid.box.push({ label: 'Pendente', value: totals.pending, decimals: 2 })
            grid.box.push({ label: 'Pagamentos', value: totals.paid, decimals: 2 })
        }
        // grid lines
        for (const item of entities) {
            let btnPerson = new GridButton({
                icon: faUser,
                label: '',
                mobile: GridItemShow.hide,
                callback: () => {
                    //window.person('show',item.person?.personId)
                },
            })

            let btnEdit = new GridButton({
                callback: () => editEntity(item.partnersEntriesId),
                label: 'Editar',
            })

            let line: GridLine = new GridLine()
            line.slots.push({ content: item.paidAt })
            line.slots.push({ content: item.availableAt })
            if (!partnerId) {
                line.slots.push({ content: item['person']?.name })
            }
            line.slots.push({ content: item['partnerPerson']?.name })
            //line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.description })

            if (item.type === 'credit') {
                line.slots.push({ content: new GridBadge({ class: GridBadgeClassEnum.badge_purple, label: 'crédito' }) })
                line.slots.push({ content: item.value })
            } else {
                line.slots.push({ content: new GridBadge({ class: GridBadgeClassEnum.badge_alert, label: 'débito' }) })
                line.slots.push({ content: item.value * -1 })
            }
            line.slots.push({ content: [btnEdit] })
            grid.lines.push(line)
        }
    }

    let dates: { from: Date; to: Date } = window.api.utils.dates.currentMonth()
    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }
</script>

<Content>
    {#if step === 1}
        <Zact>
            <div class="date input-group limit-w_400 me-1">
                <label for="" class="input-group-text">Parceiro</label>
                <select class="form-select" bind:value={partnerId} on:change={loadEntities}>
                    <option value=""></option>
                    {#each partners as partner}
                        <option value={partner.partnerId}>{partner.person?.name} {partner.status === 0 ? '(excluído)' : ''}</option>
                    {/each}
                </select>
            </div>
            <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} class="me-1" />

            <div class="spacer" />
            {#if window.store.token.permissions.partnership.entries.write}
                <button class="btn btn-secondary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo lançamento</button>
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
    {/if}
    {#if step === 2}
        <Zact>
            <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            <div class="spacer" />
            {#if !!entity.partnersEntriesId && !entity.invoiceId}
                <button class="btn btn-warning me-1" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
            {/if}
            {#if !entity.invoiceId}
                <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
            {/if}
        </Zact>

        <Zframe title="Lançamento" class="h-space">
            <div class="grid-form">
                <div class="row">
                    <div class="col-6">
                        <div class="input-group">
                            <label for="" class="input-group-text">Parceiro</label>
                            <select disabled={!!entity.invoiceId} class="form-select" bind:value={entity.partnerId}>
                                <option value=""></option>
                                {#each partners as partner}
                                    <option value={partner.partnerId}>{partner.person?.name} {partner.status === 0 ? '(excluído)' : ''}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                    {#if !!entity.invoiceId}
                        <div class="col">
                            <div class="input-group">
                                <label for="" class="input-group-text">ID de origem</label>
                                <input type="text" bind:value={entity.invoiceId} disabled class="form-control" />
                            </div>
                        </div>
                    {/if}
                </div>
                <div class="row">
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Data de referência</label>
                            <input disabled={!!entity.invoiceId} type="datetime-local" bind:value={paidAt} class="form-control" />
                        </div>
                    </div>
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Valor</label>
                            <input disabled={!!entity.invoiceId} type="number" bind:value={entity.value} class="form-control" />
                        </div>
                    </div>
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Tipo</label>
                            <select disabled={!!entity.invoiceId} class="form-select" bind:value={entity.type}>
                                <option value=""></option>
                                <option value="credit">Crédito</option>
                                <option value="debit">Débito</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Descrição</label>
                            <input disabled={!!entity.invoiceId} type="text" bind:value={entity.description} class="form-control" />
                        </div>
                    </div>
                    {#if entity.invoiceId}
                        <div class="col-4">
                            <div class="input-group">
                                <label for="" class="input-group-text">Comissão</label>
                                <input type="text" bind:value={entity.comissionPercent} disabled class="form-control" />
                                <label for="" class="input-group-text">%</label>
                            </div>
                        </div>
                    {/if}
                </div>
            </div>
        </Zframe>
    {/if}
    {#if step === 3}
        <!-- <AudienceShow on:close={showEntities} {audienceId} /> -->
    {/if}
</Content>
<LoadSpinner {show} />
